  <div class="modal-header bg-gray">
<h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  {{ message }}
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-transparent text-dark px-5 mr-2" (click)="decline()">{{ btnCancelText }}</button>
  <button type="button" class="btn btn-primary px-5" (click)="accept()">{{ btnOkText }}</button>
</div>